<template>
    <!-- Mobile-only menu entry (defensive: parent is already mobile-only, but keep this safe) -->
    <div class="lg:hidden w-full ">
        <!-- Simple link (no children) -->
        <a v-if="item.link && !item.items?.length" :href="item.link"
            :target="isExternal(item.link) ? '_blank' : undefined"
            :rel="isExternal(item.link) ? 'noreferrer noopener' : undefined"
            class="w-full flex items-center justify-between px-4 py-3 rounded-md btn-secondary">
            <span v-if="item.title" class="font-semibold text-[var(--white)]">{{ item.title }}</span>
            <Icon :name="item.icon || 'material-symbols-light:chevron-right-rounded'"
                :class="['text-2xl', item.title ? 'ml-2' : '']" />
        </a>

        <!-- Always-expanded group (no collapse support) -->
        <div v-else class="w-full">
            <!-- Section header (optionally linkable) -->
            <a v-if="item.link" :href="item.link" :target="isExternal(item.link) ? '_blank' : undefined"
                :rel="isExternal(item.link) ? 'noreferrer noopener' : undefined"
                class="w-full flex items-center justify-between px-4 py-3 rounded-md btn-secondary">
                <span class="font-semibold text-[var(--white)]">
                    <span v-if="item.title">{{ item.title }}</span>
                    <span v-else-if="item.hint" class="opacity-90">{{ item.hint }}</span>
                    <span v-else>&nbsp;</span>
                </span>
                <Icon :name="item.icon || 'material-symbols-light:chevron-right-rounded'" class="text-2xl ml-2" />
            </a>
            <div v-else class="w-full flex items-center justify-between px-4 py-3 rounded-md btn-secondary">
                <span class="font-semibold text-[var(--white)]">
                    <span v-if="item.title">{{ item.title }}:</span>
                    <span v-else-if="item.hint" class="opacity-90">{{ item.hint }}</span>
                    <span v-else>&nbsp;</span>
                </span>
                <Icon v-if="item.icon" :name="item.icon" class="text-2xl ml-2" />
            </div>

            <div class="px-4 pt-2 pb-3">
                <ul class="flex flex-col gap-1">
                    <li v-for="(mi, idx) in item.items" :key="`${mi.title || 'item'}-${idx}`">
                        <HoverMenuMobileItem :item="mi" />
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import type { TMenu } from '~/components/HoverMenu2.vue';
import type { PropType } from 'vue';

export default {
    props: {
        item: {
            type: Object as PropType<TMenu>,
            required: true,
        },
    },
    methods: {
        isExternal(link: string) {
            return /^https?:\/\//i.test(link);
        },
    },
}
</script>